/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MainLayoutStyle from '../../styles/MainLayoutStyle';
import {
  getSelectedLevelID,
  getSelectedLevelKey,
  getJourneyDetails,
  getCapstoneDetails,
  showProgress,
} from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const RightTabLists = (props) => {
  const dispatch = useDispatch();
  const classes = MainLayoutStyle();
  const IndexArray = [];
  const [menus, setMenus] = React.useState([]);
  const [menuValue, setMenuValue] = React.useState(0);
  const journeyId = useSelector((state) => state.getJourneyID);
  const levelIds = useSelector((state) => state.JourneyDetails.journeydetails.levels);
  const selectedLevelID = useSelector((state) => state.getSelectedLevelID);

  React.useEffect(() => {
    const getMenu = () => {
      if (levelIds !== undefined) {
        setMenuValue(levelIds.findIndex((elem) => elem.id === selectedLevelID));
      }
    };
    if (selectedLevelID) {
      getMenu();
    }
  }, [selectedLevelID]);
  React.useEffect(() => {
    dispatch(showProgress(true));
    const getMenus = async () => {
      const levelArr = [];
      await Service.get(apiEndpoints.JOURNEY_LEVEL_BY_JID.replace('JID', journeyId), '')
        .then((res) => {
          if (res !== undefined) {
            if (res.length > 0) {
              res.map((datas, key) => levelArr.push(`Level ${key + 1}`));
              setMenus(levelArr);
              handleRightMenuChange(0, 0);
            } else {
              dispatch(getJourneyDetails('appendLevelIds', []));
              dispatch(getCapstoneDetails('delete', []));
            }
          }
          dispatch(showProgress(false));
        })
        .catch((error) => {
          console.log(error);
          dispatch(showProgress(false));
        });
    };

    if (journeyId) {
      getMenus();
    }
  }, [levelIds]);

  const handleRightMenuChange = (event, newValue) => {
    dispatch(getSelectedLevelKey(newValue));
    setMenuValue(newValue);
    dispatch(getSelectedLevelID(levelIds[newValue].id));
  };
  const setIndexArray = (params) => {
    IndexArray.push(params);
  };

  return (
    <div className={classes.rightbar1}>
      <div className={classes.menuList}>
        <Tabs
          value={menuValue}
          onChange={handleRightMenuChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {menus?.map((menu, key) => {
            setIndexArray(key);

            return <Tab label={menu} {...a11yProps(key)} />;
          })}
        </Tabs>
      </div>
      <div onClick={props.onOpenLevelPopup}>
        <button type="submit" className={classes.menuPlusButton}>
          +
        </button>
      </div>
    </div>
  );
};

export default RightTabLists;
